module.exports = __webpack_public_path__ + "static/img/xie2.175a2d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xie2.jpg
// module id = lOtk
// module chunks = 1